'use client';

import { __makeTemplateObject } from '../../_virtual/_tslib.js';
import styled from 'styled-components';
import Typography from '../index.js';
import { colors } from '../../Colors/index.js';

var AnchorCss = styled(Typography)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    cursor: pointer;\n    &:hover,\n    &:focus {\n        color: ", " !important;\n    }\n"], ["\n    cursor: pointer;\n    &:hover,\n    &:focus {\n        color: ", " !important;\n    }\n"])), colors.secondary[40]);
var templateObject_1;

export { AnchorCss };
//# sourceMappingURL=styled.css.js.map
